export default __webpack_public_path__ + "static/media/BR - CTF5.abd32df7.png";